<template>
  <div @focus="focusIn" @focusout="focusOut" class="multiselect" tabindex="0">
    <div :class="{ selectBox: true, focused: isOpen }">
      <div>{{ text }}</div>
    </div>

    <div v-show="isOpen" class="multi">
      <div v-for="data in dataList" :key="data.id">
        <MultiSelectCheckbox :clicked="checkClicked" :data="data" :ref="'input' + data.id" :id="'label' + data.id" />
        <label :for="'label' + data.id">{{ nameGetter(data) }}</label>
      </div>
    </div>
  </div>
</template>

<script>
import MultiSelectCheckbox from "@/components/util/MultiSelectCheckbox";

export default {
  name: "MultiSelect",
  components: { MultiSelectCheckbox },
  props: {
    value: {
      type: Array,
      default: null
    },
    dataList: {
      type: Array,
      default: null
    },
    getName: {
      type: Function,
      default: null
    },
    open: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      nameGetter: function(val) {
        return val;
      },
      elements: [],
      isOpen: this.open
    };
  },

  computed: {
    text: function() {
      if (!this.value || this.value.length === 0) return "Choisir";
      else {
        let res = "";
        this.value.forEach(elt => {
          res += this.getName(elt) + ", ";
        });
        return res.substring(0, res.length - 2);
      }
    }
  },

  mounted: function() {},

  methods: {
    focusOut: function(event) {
      if (this.$el.contains(event.relatedTarget) === false) this.isOpen = false;
    },

    focusIn: function() {
      this.isOpen = true;
      if (this.isOpen) this.update();
    },

    checkClicked: function(event, data) {
      const check = event.currentTarget;
      let emit = true;

      if (check.checked === true) {
        if (this.elements.length >= 3) {
          event.preventDefault();
          emit = false;
        } else {
          this.elements.push(data);
        }
      } else {
        const index = this.elements.indexOf(data);
        this.elements.splice(index, 1);
      }
      if (emit) {
        this.$emit("input", this.elements);
      }
    },

    update: function() {
      if (this.getName) this.nameGetter = this.getName;
      if (this.value) {
        this.elements = [];
        for (let i = 0; i < this.value.length; i++) {
          this.elements.push(this.value[i]);
          const checkRef = "input" + this.value[i].id;
          const checkBox = this.$refs[checkRef];
          if (checkBox) checkBox[0].$el.checked = true;
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/vars.scss";

.selectBox {
  display: grid;
  align-content: center;
  padding-left: 10px;
  width: 100%;
  height: 37px;
  cursor: pointer;
  background: url(/assets/icons/select.png);
  background-repeat: no-repeat;
  background-position: right;
  padding-right: 25px;
  background-color: white;
  &.focused {
    border: $input_focused_border;
    box-shadow: $input_focused_shadow;
  }
}

.multiselect {
  position: relative;
}

.multi {
  display: grid;
  grid-template-columns: auto auto auto;
  grid-gap: 5px;
  margin-top: 10px;
  background-color: white;
  top: 35px;
  left: 5px;
  border: $light_border;
  box-shadow: $mid_shadow;
  padding: 5px;
  border-radius: 4px;
  border: #7fbcff 1px solid;
  box-shadow: 0 0 0px 3px #beddff;

  > div {
    display: grid;
    grid-gap: 5px;
    grid-template-columns: min-content auto;
    align-items: center;
  }
}

@media screen and (max-width: 520px) {
  .multi {
    display: grid;
    grid-template-columns: auto auto;
  }
}
</style>
